"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_broadband__device(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "broadband-hi"), /*#__PURE__*/React.createElement("g", {
    id: "3d50f17c-234f-4699-b3af-76e1347b13a3",
    "data-name": "broadband-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "36ae4878-4ff4-4d4c-87fa-459c4c1c8dcf",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c8eba312-18a9-4286-a10b-eac1e94d8dab",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c789b18c-1480-4dba-8a35-8cf8ffaf76fd",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9361381f-adca-4fcf-95c7-50f5bc7997d1",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a1b5e78a-be1b-4787-9d88-128674dc2509",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b983d9c8-fcb7-4efe-a146-504ba406c387",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "e01f1846-d70c-4681-a1f8-39080db87e0b",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 118,
    r: 8,
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ae0656b9-99ba-473c-881c-fbe39020c813",
    "data-name": "<Pfad>",
    d: "M54.17,79.37a59.13,59.13,0,0,1,83.66,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2add571-1a18-41c0-8cae-b61162d79878",
    "data-name": "<Pfad>",
    d: "M66.28,90a42.25,42.25,0,0,1,59.77,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "766d09e0-de5a-4e07-93cd-e41b07b6d204",
    "data-name": "<Pfad>",
    d: "M78.72,99.18a24.58,24.58,0,0,1,34.73,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174h0A80.23,80.23,0,0,1,16,95c0,.33,0,.66,0,1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0c0-.34,0-.67,0-1A80.23,80.23,0,0,1,96,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }))))))));
}

var _default = ic_broadband__device;
exports.default = _default;